<template>
  <div class="stuff-to-eat-info-small-card">
    <div class="stuff-to-eat-info-small-card__picture"
      v-if="picture"
      :class="{ 'is-reactive': reactive }">
      <nuttrema-iconica-sidebar-link
         class="no-hover"
         size="picture"
        :picture="picture">
      </nuttrema-iconica-sidebar-link>
    </div>
    <div class="stuff-to-eat-info-small-card__text">
      <div class="stuff-to-eat-info-small-card__text__info" :class="{ 'is-reactive': reactive }">
        {{ title }}
      </div>
      <div class="stuff-to-eat-info-small-card__text__name">
        {{ _get(details, 'name') }}
        <span v-if="showAllergens" class="stuff-to-eat-info-small-card__text--allergens">
          <nuttrema-allergens-info :allergens="_get(details, 'Allergens')"></nuttrema-allergens-info>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaAllergensInfo from 'components/ui/allergens/nuttrema-allergens-info';

export default {
  name: 'stuff-to-eat-info-small-card',
  props: {
    reactive: {
      type: Boolean,
      required: false,
      default: true,
    },
    showAllergens: {
      type: Boolean,
      required: false,
      default: true,
    },
    details: {
      required: true,
      default: null,
    },
    title: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaAllergensInfo,
    NuttremaIconicaSidebarLink,
  },
  computed: {
    picture() {
      const image = get(this.details, 'Image');
      return image ? `${process.env.IMAGES_ROOT}${this.details.Image.path}${this.details.Image.thumbnails.large.filename}` : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .stuff-to-eat-info-small-card {
    display: flex;
    align-items: center;
    .stuff-to-eat-info-small-card__picture {
      margin-right: 0.5em;
    }
    .stuff-to-eat-info-small-card__text {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .stuff-to-eat-info-small-card__text__name {
        flex-grow: 1;
        font-weight: 500;
        line-height: 1.15;
      }
      .stuff-to-eat-info-small-card__text__info {
        line-height: 1;
        font-weight: 500;
        font-size: 0.7rem;
        color: $gray-light;
        text-transform: uppercase;
      }
      .stuff-to-eat-info-small-card__text--allergens {
        float: right;
      }
    }
    .is-expanded & {
      .stuff-to-eat-info-small-card__picture.is-reactive,
      .stuff-to-eat-info-small-card__text__info.is-reactive {
        display: none;
      }
      .stuff-to-eat-info-small-card__text__name.is-reactive {
        font-weight: 500;
      }
    }
    &.is-in-section {
      padding: 0.5em 0.75em 0.5em;
      background-color: #fff;
      .stuff-to-eat-info-small-card__text__name {
        font-weight: 500;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/card/stuff-to-eat-info-small-card.vue